/* eslint-disable */

import React from 'react';
import { Routes, Route } from 'react-router-dom';

import ExtraCoupon from './ExtraCoupon.js';

function Extra(props) {
  return (
    <Routes>
      <Route
        path='/coupon'
        element={<ExtraCoupon app_hostname={props.app_hostname} permitdata={props.permitdata} />}
      />
    </Routes>
  );
}

export default Extra;
